module.exports = __webpack_public_path__ + "img/styles_background_mobile.84d17db.webp";